import React, { Component } from 'react';
import { func, oneOfType, object, array } from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

// Redux
import { connect } from 'react-redux';
import { fetchPublicPreferences } from '../actions/preferences/preferencesAction';
import { fetchRedirectNeeded, getPracticeDetails } from "../actions/public/publicActions";
import { closeAlertDialog, closeConfirmDialog, openErrorDialog } from '../actions/dialog/dialogActions';

import portalTheme from '../themes/portalTheme';
import LoadingState from '../components/LoadingState';
import Layout from '../components/Layout';
import MainMenu from '../components/MainMenu';
import PageMeta from '../components/PageMeta';
import PortalDialog from '../components/PortalDialog';
import Footer from "../components/Footer/Footer";
import s from './UnauthLayout.css';

class UnauthLayout extends Component {
  static propTypes = {
    alertDialog: object,
    children: oneOfType([
      array,
      object
    ]),
    closeAlertDialog: func,
    closeConfirmDialog: func,
    confirmDialog: object,
    fetchPublicPreferences: func,
    fetchRedirectNeeded: func,
    fullPageLoadingState: object,
    getPracticeDetails: func,
    metadata: object,
    params: object,
    route: object,
    routeParams: object,
    router: object,
    routes: array,
  };

  componentDidMount() {
    this.props.fetchRedirectNeeded();
    this.props.fetchPublicPreferences();
    this.props.getPracticeDetails();
  }

  // return true; from the child callback will close the dialog, otherwise it stays open
  handleAlertOkCallback = () => {
    if (!this.props.alertDialog.okCallback || this.props.alertDialog.okCallback()) {
      this.props.closeAlertDialog();
    }
  };

  // return true; from the child callback will close the dialog, otherwise it stays open
  handleConfirmOkCallback = () => {
    if (!this.props.confirmDialog.okCallback || this.props.confirmDialog.okCallback()) {
      this.props.closeConfirmDialog();
    }
  };

  render = () => {
    const path = this.props.location.pathname;

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
        <div className={s.container}>
          <Layout column fullscreen staticX staticY>
            <PageMeta
                title={this.props.metadata.pageTitle}
                description={this.props.metadata.pageDescription}
            />
            <Layout mobileColumn staticX>
              <MainMenu
                  activeItemKey={path}
                  isUnauth
              />

              {this.props.children}

            </Layout>
            {this.props.fullPageLoadingState.loading &&
                <LoadingState context="fullPageTakeOver" />
            }
            <PortalDialog
                id="alertDialog"
                open={this.props.alertDialog.open}
                error={this.props.alertDialog.error}
                title={this.props.alertDialog.title}
                content={this.props.alertDialog.content}
                okCallback={this.handleAlertOkCallback}
                okOnly
                modal
            />
            <PortalDialog
                id="confirmDialog"
                open={this.props.confirmDialog.open}
                error={this.props.confirmDialog.error}
                title={this.props.confirmDialog.title}
                content={this.props.confirmDialog.content}
                okCallback={this.handleConfirmOkCallback}
                cancelLabel={this.props.confirmDialog.cancelLabel}
                okLabel={this.props.confirmDialog.okLabel}
                cancelCallback={this.props.confirmDialog.okCallback}
                modal
            />
          </Layout>
          <Footer />
        </div>
      </MuiThemeProvider>
    );
  };
}

const mapStateToProps = (state) => ({
  alertDialog: state.alertDialog,
  confirmDialog: state.confirmDialog,
  fullPageLoadingState: state.fullPageLoadingState,
  metadata: state.metadata,
});

const mapDispatchToProps = dispatch => ({
  fetchPublicPreferences: () => dispatch(fetchPublicPreferences()),
  fetchRedirectNeeded: () => dispatch(fetchRedirectNeeded()),
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  closeConfirmDialog: () => dispatch(closeConfirmDialog()),
  getPracticeDetails: () => dispatch(getPracticeDetails()),
  openErrorDialog: (dialog) => dispatch(openErrorDialog(dialog)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnauthLayout);



// WEBPACK FOOTER //
// ./src/layouts/UnauthLayout.js